import { DocumentNode, gql } from "@apollo/client";
import {
    baseCategoryTaxonomy,
    baseGraphicElementContent,
    baseKpiReportTemplateContent,
    baseWaterProviderTaxonomy
} from "./base";

const CONTENT_QUERY = `
        ${baseGraphicElementContent},
        displayFor,
        type,
        providers {
            ${baseWaterProviderTaxonomy}
        },
        kpiReportTemplate {
            ${baseKpiReportTemplateContent}
        }
`;

const CATEGORY_QUERY = `
        ${baseCategoryTaxonomy},
        description {
            value,
            format,
            processed
        },
        bulkProviderDescription {
            value,
            format,
            processed
        },
        bulkSupportingInfo {
            value,
            format,
            processed
        },
        supportingInfo {
            value,
            format,
            processed
        },
        replaceWhenBulks,
        displayName,
        displayType,
        theme,
        faIcon,
        parentId,
        graphContent {
            ${CONTENT_QUERY}
        },
        tableContent {
            ${CONTENT_QUERY}
        },
        infoContent {
            ${CONTENT_QUERY}
        },

        comparisonGraphContent {
            ${CONTENT_QUERY}
        },
        comparisonTableContent {
            ${CONTENT_QUERY}
        },
        comparisonInfoContent {
            ${CONTENT_QUERY}
        }
`;

const GET_ALL_CATEGORIES_FOR_LOCATIONS = () => {
    return gql`
        query LocationCategories($providerAdminIds: [String!]) {
            result: getCategoriesForLocations(providerAdminIds: $providerAdminIds) { 
              ${CATEGORY_QUERY}
            }
        }
    `;
};

export const GET_ALL_CATEGORIES_FOR_LOCATIONS_PARAMS = (
    locationAdminIds: string[]
): {
    query: DocumentNode;
    options: {
        skip: boolean;
        variables: {
            providerAdminIds: string[];
        };
    };
} => {
    const allow = locationAdminIds?.filter(d => d != null && d.trim() !== "")?.length > 0 ? true : false;

    return {
        query: GET_ALL_CATEGORIES_FOR_LOCATIONS(),
        options: {
            skip: !allow,
            variables: {
                providerAdminIds: [
                    "dummyLocation",
                    ...(locationAdminIds?.filter(d => d != null && d.trim() !== "") ?? [])
                ]
            }
        }
    };
};
